import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-login-external-page',
    templateUrl: './login-external-page.component.html',
    styleUrls: ['./login-external-page.component.scss'],
    standalone: false
})
export class LoginExternalPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
